module.exports = __webpack_public_path__ + "media/ring.ce45.wav";